<template>
	 <Suspense>
      <RouterView v-slot="{ Component, route }">
        <AppShareLayout v-if="route.meta.layout === 'share'">
          <component :is="Component" />
        </AppShareLayout>

        <component v-else :is="Component" />
      </RouterView>

    </Suspense>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useStore } from './store';
import { useAppInit } from '@h5-monorepo/shared/composables/useAppInit';
import { useKeepAlive } from '@h5-monorepo/shared/composables/useKeepAlive';
import { useVisibility } from '@h5-monorepo/shared/composables/useVisibility';
import { hideHtmlLoadingWhenReady } from '@h5-monorepo/shared/composables/useLoading';
import AppShareLayout from './layouts/AppShareLayout.vue'

// 获取路由实例
const router = useRouter();

// 应用初始化 - 移动端适配、字体设置等
useAppInit({
	designWidth: 375,
	baseFontSize: 37.5,
	pageScale: 2
});

// 路由缓存管理
useKeepAlive({ router });

// 页面可见性管理
useVisibility();
// Store 初始化完成后，立即订阅登录事件
const store = useStore();
store.initLoginEventSubscription();

// ✨ 优化：等待路由完全加载和首个页面组件挂载后，再隐藏HTML loading骨架屏
// 300ms延迟加载：快速加载无loading，弱网加载显示loading
hideHtmlLoadingWhenReady(router);
</script>

<style lang="scss">
@use '@h5-monorepo/shared/assets/scss/index.scss' as *;
/* 主题全局样式（字体 / 正文色 / shared 组件补丁）由 shared presetH5Theme 生成，见 uno.config.ts */
#app {
	font-size: 0.346rem;
	overflow: hidden;
}
/* 小程序页面 */
.mini-page {
	height: 100vh;
	width: 100vw;
	position: relative;
	z-index: 0;
	background-color: $background;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	.back-btn {
		width: 0.952rem;
		height: 0.952rem;
		background-color: #00000033;
		border-radius: 50%;
		z-index: 5000;
		transition: all 0.2s;
	}
	.back-btn:hover,
	.back-btn:active {
		opacity: 0.7;
	}
	.page-container {
		width: 100vw;
		flex: 1;
		overflow: hidden;
		.page {
			height: 100%;
			width: 100%;
		}
	}
}
.navbar-slide-y-enter-active,
.navbar-slide-y-leave-active {
	transition: all 0.2s;
}

.navbar-slide-y-enter-from,
.navbar-slide-y-leave-to {
	opacity: 0;
	transform: translateY(-100%);
}
img {
	-webkit-touch-callout: none; /* 禁止 iOS Safari 长按弹出保存菜单 */
	-webkit-user-select: none; /* 禁止选中 */
	user-select: none;
}
</style>
